import { Controller } from "@hotwired/stimulus"

const DEFAULT_CARD_SELECTOR = ":scope > li"

export default class extends Controller {
  static values = {
    visibleCount: { type: Number, default: 4 },
    cardSelector: { type: String, default: DEFAULT_CARD_SELECTOR }
  }

  connect() {
    this.updateMaxHeight = this.updateMaxHeight.bind(this)
    this.scheduleUpdate = this.scheduleUpdate.bind(this)

    this.resizeObserver = new ResizeObserver(this.scheduleUpdate)
    this.resizeObserver.observe(this.element)
    this.observeCards()

    window.addEventListener("resize", this.scheduleUpdate)
    this.scheduleUpdate()
  }

  disconnect() {
    window.removeEventListener("resize", this.scheduleUpdate)
    this.resizeObserver?.disconnect()
    if (this.frameId) cancelAnimationFrame(this.frameId)
  }

  scheduleUpdate() {
    if (this.frameId) cancelAnimationFrame(this.frameId)
    this.frameId = requestAnimationFrame(() => {
      this.updateMaxHeight()
      this.frameId = null
    })
  }

  observeCards() {
    this.cardElements().forEach((card) => this.resizeObserver.observe(card))
  }

  cardElements() {
    return Array.from(this.element.querySelectorAll(this.cardSelectorValue))
  }

  updateMaxHeight() {
    const cards = this.cardElements()
    if (cards.length === 0) {
      this.element.style.maxHeight = ""
      return
    }

    if (cards.length <= this.visibleCountValue) {
      this.element.style.maxHeight = ""
      return
    }

    const visibleCount = this.visibleCountValue
    let totalHeight = 0

    for (let index = 0; index < visibleCount; index += 1) {
      totalHeight += cards[index].getBoundingClientRect().height
    }

    if (totalHeight <= 0) {
      this.element.style.maxHeight = ""
      return
    }

    const gap = this.listGapPx()
    const gapCount = Math.max(0, visibleCount - 1)
    const maxHeight = Math.floor(totalHeight + gap * gapCount)

    this.element.style.maxHeight = `${maxHeight}px`
  }

  listGapPx() {
    const styles = getComputedStyle(this.element)
    const gap = parseFloat(styles.rowGap || styles.gap)

    return Number.isFinite(gap) ? gap : 0
  }
}
